import { ReactNode } from 'react';

import { create } from 'zustand';

interface LayoutStore {
  actions: ReactNode | null;
  setActions: (content: ReactNode) => void;
  formActions: ReactNode | null;
  setFormActions: (content: ReactNode) => void;
}
export const useTopbarStore = create<LayoutStore>((set) => ({
  actions: null,
  setActions: (content) => set({ actions: content }),
  formActions: null,
  setFormActions: (content) => set({ formActions: content }),
}));
